import FrontNewsIndex from './news/index';
customElements.define('news-v2-front-news-index', FrontNewsIndex,{extends: 'div'});

import NewsLike from './components/NewsLike';
customElements.define('news-v2-front-news-like', NewsLike,{extends: 'a'});

import CommentsList from './components/CommentsList';
customElements.define('news-v2-front-comments-list', CommentsList,{extends: 'div'});